import type { CoverageEntitiesResult } from '../api';
import { formatPct, formatPopulation } from '../summaryFormat';

/** Resumen chico de "dentro de la cobertura" — mismo componente en Ficha y Visor. */
export function CoverageSummary({
  coverage,
  className = 'ft-block',
}: {
  coverage: CoverageEntitiesResult | null;
  className?: string;
}): JSX.Element {
  if (!coverage) return <div className={`${className} ft-block-loading`}>Calculando cobertura…</div>;
  return (
    <div className={className}>
      <p className="ft-block-title">Cobertura de la variante</p>
      <div className="ft-kpi-row">
        <div className="ft-kpi">
          <span className="ft-kpi-value">{formatPopulation(coverage.populationCovered)}</span>
          <span className="ft-kpi-label">Habitantes ({formatPct(coverage.populationCoveragePct)})</span>
        </div>
        <div className="ft-kpi">
          <span className="ft-kpi-value">{coverage.education.count}</span>
          <span className="ft-kpi-label">Educación</span>
        </div>
        <div className="ft-kpi">
          <span className="ft-kpi-value">{coverage.health.count}</span>
          <span className="ft-kpi-label">Salud</span>
        </div>
        <div className="ft-kpi">
          <span className="ft-kpi-value">{coverage.civic.count}</span>
          <span className="ft-kpi-label">Cívico / público</span>
        </div>
        <div className="ft-kpi">
          <span className="ft-kpi-value">
            {coverage.greenSpace.accessibleCount + coverage.sportsFacility.accessibleCount}
          </span>
          <span className="ft-kpi-label">Espacios verdes / deporte accesibles</span>
        </div>
      </div>
    </div>
  );
}
